export default __webpack_public_path__ + "static/media/paypal.23de6718.png";